import { useState, useEffect } from "react";
import {
  Eye,
  EyeOff,
  Mail,
  Lock,
  ArrowRight,
  CircleUserRound,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import pkceChallenge from "pkce-challenge";

import axios from "axios";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card.jsx";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { useUserContext } from "../context/UserContext.jsx";
import { validateToken } from "../utils/helper";
import logo from "../assets/top.png";
import { toast } from "react-toastify";
import bg from "../assets/bg.png";

export default function Login() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setUserId, setPartnerId } = useUserContext();

  const handleLogin = async (e) => {
    e.preventDefault();
    const { code_challenge, code_verifier } = await pkceChallenge();

    localStorage.setItem("pkce_verifier", code_verifier);

    const params = new URLSearchParams({
      client_id: import.meta.env.VITE_CLIENT_ID,
      response_type: "code",
      scope: "openid+profile+email",
      redirect_uri: import.meta.env.VITE_REDIRECT_URI,
      code_challenge: code_challenge,
      code_challenge_method: "S256",
    });

    window.location.href = `${
      import.meta.env.VITE_BASE_URL
    }/login?${params.toString()}`;
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("loggedOut")) {
      toast.success("You've been signed out successfully.");
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const isTokenValid = validateToken(token);
      if (isTokenValid) {
        navigate("/lead_inventory/yours");
      }
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cover bg-center p-4 bg-[linear-gradient(335deg,_#818cf8_0%,_#c7d2fe_0%,_white_95%)]">
      <div className="w-full max-w-md">
        <form onSubmit={handleLogin}>
          <Card className="rounded-2xl overflow-hidden shadow-xl border-0 bg-white/80 backdrop-blur-sm">
            {/* FULL-WIDTH TOP BANNER */}
            <div className="w-full h-24">
              <img
                src={logo}
                alt="Logo"
                className="w-full h-full object-cover block"
              />
            </div>

            {/* CONTENT WITH PADDING */}
            <CardHeader className="text-center space-y-2 p-6">
              <CardTitle className="text-2xl font-bold text-slate-800">
                CSP 4.0
              </CardTitle>
              <CardDescription className="text-slate-600">
                Sign in to your account to continue
              </CardDescription>
            </CardHeader>

            <CardContent className="space-y-6">
              <Button
                type="submit"
                className="w-full h-12 bg-indigo-500 hover:bg-indigo-600 text-white font-medium transition-all duration-200 hover:shadow-lg group"
                disabled={isLoading}
              >
                {isLoading ? (
                  <div className="flex items-center space-x-2">
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    <span>Signing in...</span>
                  </div>
                ) : (
                  <div className="flex items-center space-x-2">
                    <span>Sign in with SSO</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                )}
              </Button>
            </CardContent>
          </Card>
        </form>
      </div>
    </div>
  );
}
